import type { ContextState } from "./types";

export const defaultState: ContextState = {
  messages: [],
};
